import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';

import { useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

import { liveMapSlice } from '../../liveMap.slice';

export const AssignmentLocationsSearch = () => {
  const assignmentLocationsSearchTerm = useAppSelector(
    (state) => state.liveMap.assignmentLocationsSearchTerm
  );
  const { inputValue, handleInputChange } = useDebouncedSearch(
    liveMapSlice.actions.setAssignmentLocationsSearchTerm,
    assignmentLocationsSearchTerm
  );

  return (
    <div>
      <SearchTypeahead
        dataTestId="assignment-locations-search"
        placeholder="Search crew schedules"
        onChange={handleInputChange}
        value={inputValue}
      />
    </div>
  );
};
